import { Checkbox } from '@/components/checkbox/checkbox'

import { cn } from '@/lib/utils'

import { type SelectOtherCasesButtonProps } from './select-other-cases-button'

export type CaseCheckboxListProps = SelectOtherCasesButtonProps

export const CaseCheckboxList = ({
  beingUpdatedCaseId,
  isDisabledAllCheckbox,
  dataAllApplicantCases,
  dataProUserSelectedCases,
  onCheckedChange,
}: CaseCheckboxListProps) => {
  if (!dataAllApplicantCases || dataAllApplicantCases.length === 0) {
    return (
      <div
        className={cn(
          'text-center text-xs text-foreground text-slate-900',
          'bg-white',
          'rounded-[10px]',
          'px-2 py-3',
          'border border-elevated'
        )}
      >
        No cases to display.
      </div>
    )
  }

  return (
    <div className={cn('flex flex-col gap-y-3', 'max-h-[400px] overflow-y-auto', 'mt-2.5')}>
      {dataAllApplicantCases.map(({ caseType, caseId, caseNumber }) => (
        <label key={caseId} className={cn('flex items-center gap-x-2', 'cursor-pointer')}>
          <Checkbox
            variant="black"
            loading={beingUpdatedCaseId === caseId}
            disabled={isDisabledAllCheckbox}
            checked={
              dataProUserSelectedCases
                ? dataProUserSelectedCases.some(({ caseId: selectedCaseId }) => selectedCaseId === caseId)
                : false
            }
            onCheckedChange={(checked) => onCheckedChange(caseId, checked)}
          />
          <span className={cn('text-sm font-normal text-foreground')}>
            {caseType} {caseNumber}
          </span>
        </label>
      ))}
    </div>
  )
}
